import { rem } from "polished";
import styled from "styled-components";

const Container = styled.span`
  width: ${rem(175)};
`;

const Outline = styled.div`
  border: ${rem(1)} dashed #d2afff;
  border-radius: ${rem(4)};
  width: ${rem(160)};
  height: ${rem(100)};
`;

const Image = styled.img`
  position: absolute;
  width: ${rem(160)};
  height: ${rem(86)};
  top: ${rem(40)};
  right: ${rem(56)};
  border-radius: ${rem(4)};
  border: ${rem(1)} solid var(--color-blue-400);
  box-shadow: -0.125rem 0.5rem 1rem rgba(0, 0, 0, 0.04),
    0.25rem 0.5rem 0.5rem rgba(0, 0, 0, 0.04),
    0.25rem 0.25rem 0.25rem rgba(0, 0, 0, 0.02),
    0.125rem 0.125rem 0.125rem rgba(0, 0, 0, 0.02);
`;

const CursorImage = styled.img`
  position: absolute;
  width: ${rem(18)};
  height: ${rem(18)};
  top: ${rem(104)};
  right: ${rem(86)};
`;

const Sticky = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${rem(16)};
  position: sticky;
  bottom: 0;
  background-color: #fff;
  padding: ${rem(8)};
`;

export { CursorImage, Image, Container, Outline, Sticky };
